import React from 'react';

export const Label = ({ text }) => {
  return (
    <label className="Form__Label Form__Label--bold">
      {text}
    </label>
  )
}

